import { Box, Stack, Typography } from '@mui/material'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'

// Mockup-faithful decorative bar — 8 stages, ordered booking → billing.
// Reflects the API fields the user asked us to surface (incl. "Proship Pushed").
const stages = [
  { label: 'API Weight Pushed by Client', sub: 'From Client API / OMS', dot: '#3b82f6', bg: '#eff6ff' },
  { label: 'Proship Pushed Weight', sub: 'Pushed to Courier', dot: '#6366f1', bg: '#eef2ff' },
  { label: 'Prozo Predicted Weight', sub: 'Via Past Database', dot: '#8b5cf6', bg: '#f5f3ff' },
  { label: 'Transit Weight', sub: 'DWS or Sorter', dot: '#f59e0b', bg: '#fffbeb' },
  { label: 'Courier Billed Weight', sub: 'Billed by Courier', dot: '#eab308', bg: '#fefce8' },
  { label: 'Courier Billed Slab', sub: 'Slab-Rounded', dot: '#ef4444', bg: '#fef2f2' },
  { label: 'Weight Charged to Client', sub: 'Billed to Client', dot: '#10b981', bg: '#ecfdf5' },
  { label: 'Weight Slab Billed to Client', sub: 'Slab-Rounded', dot: '#10b981', bg: '#ecfdf5' },
]

export default function WeightFlowHeader() {
  return (
    <Stack
      direction='row'
      alignItems='stretch'
      spacing={0}
      sx={{
        width: '100%',
        overflowX: 'auto',
        py: 1.5,
        px: 1,
        bgcolor: '#fff',
        borderRadius: 1,
        boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
      }}
    >
      {stages.map((s, idx) => (
        <Box key={s.label} sx={{ display: 'flex', alignItems: 'center', flex: '1 0 auto' }}>
          <Box
            sx={{
              flex: '1 0 140px',
              minWidth: 140,
              bgcolor: s.bg,
              borderRadius: 1,
              p: 1.25,
              textAlign: 'center',
              border: '1px solid rgba(0,0,0,0.04)',
            }}
          >
            <Box
              component='span'
              sx={{
                display: 'inline-block',
                width: 8,
                height: 8,
                borderRadius: '50%',
                bgcolor: s.dot,
                mb: 0.5,
              }}
            />
            <Typography sx={{ fontSize: 12, fontWeight: 700, color: '#111', lineHeight: 1.2 }}>
              {s.label}
            </Typography>
            <Typography sx={{ fontSize: 10.5, color: '#6b7280', mt: 0.25 }}>{s.sub}</Typography>
          </Box>
          {idx < stages.length - 1 && (
            <ChevronRightIcon sx={{ color: '#cbd5e1', fontSize: 18, mx: 0.25 }} />
          )}
        </Box>
      ))}
    </Stack>
  )
}
